export const SEARCH_API = 'api/company/company-benefit-stats-and-comments';

export const companyFieldLabelProps = {
    label: 'Search by Company',
    shouldShowTooltip: false,
};

export const industryFieldLabelProps = {
    label: 'Search by Industry',
    shouldShowTooltip: false,
};

export const TABLE_HEADERS = [
    {
        label: 'Name',
        sortOptions: [
            { label: 'A - Z', value: 'asc' },
            { label: 'Z - A', value: 'desc' },
        ],
        value: 'companyName',
    },
    {
        label: 'Industry',
        sortOptions: [
            { label: 'A - Z', value: 'asc' },
            { label: 'Z - A', value: 'desc' },
        ],
        value: 'industry',
    },
    {
        sublabel: 'Maternity Leave',
        label: 'Paid (weeks)',
        sortOptions: [
            { label: 'High - Low', value: 'desc' },
            { label: 'Low - High', value: 'asc' },
        ],
        value: 'paidMaternity',
    },
    {
        sublabel: 'Maternity Leave',
        label: 'Unpaid (weeks)',
        sortOptions: [
            { label: 'High - Low', value: 'desc' },
            { label: 'Low - High', value: 'asc' },
        ],
        value: 'unpaidMaternity',
    },
    {
        sublabel: 'Paternity Leave',
        label: 'Paid (weeks)',
        sortOptions: [
            { label: 'High - Low', value: 'desc' },
            { label: 'Low - High', value: 'asc' },
        ],
        value: 'paidPaternity',
    },
    {
        sublabel: 'Paternity Leave',
        label: 'Unpaid (weeks)',
        sortOptions: [
            { label: 'High - Low', value: 'desc' },
            { label: 'Low - High', value: 'asc' },
        ],
        value: 'unpaidPaternity',
    },
    {
        label: 'Add a Tip',
    },
];

export const LEAVE_POLICY_TYPES = [
    'paidMaternity',
    'unpaidMaternity',
    'paidPaternity',
    'unpaidPaternity',
];

export const PAGE_LIMIT = 20;
export const THROTTLE_INTERVAL = 200;
